import React from 'react';
import classNames from 'classnames';
import TextExtended from '../components/text-extended/text-extended';
import { useTranslate } from '../context/api-context/translations/use-translate';
import styles from './list-loading-state.scss';
import { Spinner } from 'wix-ui-tpa/cssVars';
import { LIST_LOADING } from '../../common/constants/data-hooks';
import { useConfiguration } from '../context/configuration-context/use-configuration';
const ListLoadingState = () => {
    const t = useTranslate();
    const { screenshotMode } = useConfiguration();
    return (React.createElement("div", { "data-hook": LIST_LOADING, className: classNames(styles.container, 'wc-separator-color') },
        React.createElement("div", { className: styles.spinner },
            React.createElement(Spinner, { diameter: 17, isStatic: screenshotMode })),
        React.createElement("div", { className: styles.text },
            React.createElement(TextExtended, { priority: "primary" }, t('empty-state.list-loading-text')))));
};
export default ListLoadingState;
//# sourceMappingURL=list-loading-state.js.map